import { useCallback, useMemo } from 'react';

import { selectOrdersRecognitionSidebarMode } from '@entities/sidebar/slice/orders-recognition-sidebar.selectors';
import { ordersRecognitionSidebarActions } from '@entities/sidebar/slice/orders-recognition-sidebar.slice';

import { useAppDispatch, useAppSelector } from '../../../store';

export const useOrdersRecognitionSidebarController = () => {
    const dispatch = useAppDispatch();
    const mode = useAppSelector(selectOrdersRecognitionSidebarMode);

    const isOpen = mode !== 'closed';
    const halfClose = mode === 'half';

    const openFull = useCallback(
        () => dispatch(ordersRecognitionSidebarActions.openFull()),
        [dispatch]
    );
    const openHalf = useCallback(
        () => dispatch(ordersRecognitionSidebarActions.openHalf()),
        [dispatch]
    );
    const close = useCallback(() => dispatch(ordersRecognitionSidebarActions.close()), [dispatch]);
    const toggle = useCallback(
        () => dispatch(ordersRecognitionSidebarActions.toggle()),
        [dispatch]
    );

    return useMemo(
        () => ({ mode, isOpen, halfClose, openFull, openHalf, close, toggle }),
        [mode, isOpen, halfClose, openFull, openHalf, close, toggle]
    );
};
